import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { portalRoutes } from "./portal.routes";
window.Vapor = require('laravel-vapor');
const router = createRouter({
    history: createWebHistory(),
    routes: portalRoutes
});
const app = createApp({});
app.use(router).mount('#app');
